function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useBadgeUrl } from "./common";
import { Link } from "../../navigation";
import { Image } from "../../medias";
export const DEEZER_APP_GOOGLE_LINK = 'https://play.google.com/store/apps/details?id=deezer.android.app';
export const PlayStoreBadge = (_param)=>{
    var { href = DEEZER_APP_GOOGLE_LINK, locale, overrideImgUrl, height = '50px', h } = _param, linkProps = _object_without_properties(_param, [
        "href",
        "locale",
        "overrideImgUrl",
        "height",
        "h"
    ]);
    const finalHeight = h !== null && h !== void 0 ? h : height;
    const url = useBadgeUrl('play', {
        overrideImgUrl,
        locale
    });
    return /*#__PURE__*/ _jsx(Link, _object_spread_props(_object_spread({
        href: href,
        flexShrink: 0
    }, linkProps), {
        h: finalHeight,
        children: /*#__PURE__*/ _jsx(Image, {
            alt: "Google Play Store",
            src: url,
            h: h !== null && h !== void 0 ? h : height,
            w: "auto",
            htmlWidth: "646",
            htmlHeight: "250",
            objectFit: "scale-down",
            sx: {
                imageRendering: '-webkit-optimize-contrast'
            }
        })
    }));
};
/**
 * @deprecated - now only a pass through. Badges accept deezer-seo format by default.
 * @see [the deezer compatibility package](https://github.deezerdev.com/Deezer/deezerlib/tree/master/packages/utils/deezer-compatibility)
 * If you want need to "translate" from other locale mechanism to another
 */ export const localeToGoogleLang = (locale)=>locale;
/**
 * @deprecated - now only a pass through. Badges accept deezer-seo format by default.
 * @see [the deezer compatibility package](https://github.deezerdev.com/Deezer/deezerlib/tree/master/packages/utils/deezer-compatibility)
 * If you want need to "translate" from other locale mechanism to another
 */ export const isGoogleLang = ()=>true;

//# sourceMappingURL=PlayStore.js.map